import { JSX } from 'react';
import { Create, SimpleForm } from 'react-admin';
import { LlmModelPriceFields } from '../edit/components/LlmModelPriceFields';
import { ChatFieldBridge } from '../chat-bot/components/ChatFieldBridge';

export const LlmModelPriceCreate: () => JSX.Element = (): JSX.Element => {
    return (
        <Create redirect="list">
            <SimpleForm>
                <LlmModelPriceFields />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
